import apiClient from "@/services/apiClient";

export async function getMyCertificates() {
  const { data } = await apiClient.get("/backend/dashboard/certificates");
  return data;
}

export async function getCertificateForCourse(courseId) {
  const { data } = await apiClient.get(`/backend/dashboard/certificates/${courseId}`);
  return data;
}

export async function verifyCertificate(certificateNumber) {
  const { data } = await apiClient.get(`/public/certificates/verify/${certificateNumber}`);
  return data;
}

/**
 * Downloads the PDF for a course's certificate and triggers a browser save. Goes through a
 * dedicated proxy route (not apiClient's generic JSON path) since the response body is binary.
 */
export async function downloadCertificatePdf(courseId, filename) {
  const response = await apiClient.get(`/backend/certificates/${courseId}/pdf`, {
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename || "certificate.pdf";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
